// Static asset URLs for The Quick Brownie

export const LOGO = "https://customer-assets.emergentagent.com/job_865b4dbe-c58c-4335-9acb-23d734fc8f3b/artifacts/oe7o0i2i_thequickbrownie_logo-transp.png";

export const WHATSAPP_NUMBER = "5521997692454";
export const WHATSAPP_DISPLAY = "+55 21 99769-2454";
export const INSTAGRAM = "thequickbrownie";
export const EMAIL = "thequickbrownie@gmail.com";

// Per-flavor pricing
export const PRICE_RECHEADO = 23.9;
export const PRICE_TRADICIONAL = 19.9;
export const KIT5_PRICE = 97.9;

export const FLAVORS = [
  {
    slug: "doce-de-leite",
    value: "doce de leite",
    label: "Doce de Leite",
    n: "01",
    tag: "Clássico brasileiro",
    desc: "Cacau denso com recheio cremoso de doce de leite e nozes crocantes por cima.",
    img: "https://customer-assets.emergentagent.com/job_clean-brownie-shop/artifacts/f12fzytc_doce-de-leite-confiteria.png",
    collab: "A Confiteria · Doce de Leite Fit",
    price: PRICE_RECHEADO,
  },
  {
    slug: "beijinho-de-coco",
    value: "beijinho de coco",
    label: "Beijinho de Coco",
    n: "02",
    tag: "Tradição que abraça",
    desc: "Beijinho cremoso de coco no centro, brownie denso de cacau e nibs no topo.",
    img: "https://customer-assets.emergentagent.com/job_clean-brownie-shop/artifacts/hg13vrd4_beijinho-de-coco-confiteria.png",
    collab: "A Confiteria · Beijinho de Coco Fit",
    price: PRICE_RECHEADO,
  },
  {
    slug: "cookies-cream",
    value: "cookie & cream",
    label: "Cookie & Cream",
    n: "03",
    tag: "Crocância icônica",
    desc: "Pedaços de cookie e creme branco entre cacau intenso e nibs crocantes.",
    img: "https://customer-assets.emergentagent.com/job_clean-brownie-shop/artifacts/3s0xxt47_cookies-cream-confiteria.png",
    collab: "A Confiteria · Cookies & Cream Fit",
    price: PRICE_RECHEADO,
  },
  {
    slug: "creme-de-pistache",
    value: "creme de pistache",
    label: "Creme de Pistache",
    n: "04",
    tag: "Assinatura sofisticada",
    desc: "Brigadeiro de pistache verdadeiro, sedoso, com nibs de cacau no topo.",
    img: "https://customer-assets.emergentagent.com/job_clean-brownie-shop/artifacts/g085t9y0_pistache-confiteria.png",
    collab: "A Confiteria · Brigadeiro de Pistache Fit",
    price: PRICE_RECHEADO,
  },
  {
    slug: "beauty-protein",
    value: "beauty protein",
    label: "Beauty Protein",
    n: "05",
    tag: "Tradicional · Sem collab",
    desc: "Receita tradicional protéica. Denso, puro, generoso em nibs de cacau no topo.",
    img: "https://customer-assets.emergentagent.com/job_clean-brownie-shop/artifacts/9nu1vftw_beauty-protein-tradicional.png",
    collab: null,
    price: PRICE_TRADICIONAL,
  },
];
